<script lang="typescript">
  // packages
  import { intcomma, pluralize } from 'journalize';
  import Photos from './Photos.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { NationalInterface, PresidentRaceFeed } from '../interfaces';
  export let feed: Readable<NationalInterface>;
    /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

  // candidate headshots from crosswalk
  const harrisHead = crosswalk["polid-64984"];
  const trumpHead = crosswalk["polid-8639"];

  $: electorsTotal = $feed.electors_total;
  $: electorsRemaining = $feed.electors_remaining;
  $: electorsToWin = $feed.electors_to_win;
  $: harris = $feed.harris;
  $: trump = $feed.trump;

  $: harrisWidth = (harris.electors_won / electorsTotal) * 100;
  $: trumpWidth = (trump.electors_won / electorsTotal) * 100;
  $: remainingWidth = (electorsRemaining / electorsTotal) * 100;
 
  function generateariaLabel (t,h){
    let tElectorsWon = t.electors_won;
    let hElectorsWon = h.electors_won;
    if ((tElectorsWon>hElectorsWon)&& (!t.is_winner)) { // trump leading, not called winner
      return  `Trump is leading with ${tElectorsWon} electoral votes. Harris has ${hElectorsWon} electoral votes.`
    } else if ((hElectorsWon>tElectorsWon) && (!h.is_winner)) { // harris leading, not called winner
      return `Harris is leading with ${hElectorsWon} electoral votes. Trump has ${tElectorsWon} electoral votes.`
    } else if (t.is_winner) { // trump is called winner
      return  `The race has been called for Trump with ${tElectorsWon} electoral votes. Harris has ${hElectorsWon} electoral votes.`
    }else if (h.is_winner) { // harris is called winner
      return  `The race has been called for Harris with ${hElectorsWon} electoral votes. Trump has ${tElectorsWon} electoral votes.`
    } else if (tElectorsWon === hElectorsWon) { // tied
      return `Harris and Trump have ${tElectorsWon} electoral votes each.`
    } else {
      return ''
    }
  }

  $: electorsText = generateariaLabel(trump, harris)
  
  $: ariaLabel = `Bar chart shows number of electoral votes for Kamala Harris and Donald Trump. A candidates need ${electorsToWin} electors to win. ${electorsText}`
 
</script>
  
  <div role="presentation" class="display-flex w-full position-relative text-sans-serif space-y-n2" aria-label={ariaLabel}>
    <!-- harris section -->
   <div class="display-flex color-dem-dark image-style">
      <div class="duo-head left harris-headshot">
        <Photos
          name="Kamala Harris"
          src={harrisHead.jpg || harrisHead.png}
          avif={harrisHead.avif}
          webp={harrisHead.webp}
          party={harris.party}
        />        
      </div>
   </div>
    
    <div style="flex:1;">
      <!-- electors info -->
       <dl class="display-flex justify-between leading-none text-medium mb-14">    
         <!-- harris info -->
          <div class="text-left color-dem-dark" style="width: 40%;">
            <div class="text-5xl mb-11 text-medium">{harris.electors_won}</div>
            <dt class="balance-name text-2xl text-bold">
              Harris{#if harris.is_winner}<span class="candidate-checkmark" aria-label="checkmark, winner">✓</span>{/if}
            </dt>
          </div>

          <!-- electors win text-->
          <div class="text-center to-win-text text-bold">
            {electorsToWin} electoral votes to&nbsp;win
          </div>

          <!-- trump info-->
          <div class="text-right color-gop-dark" style="width: 40%;">
            <div class="text-5xl mb-11 text-medium">{trump.electors_won}</div>
            <dt class="balance-name text-2xl text-bold">
              {#if trump.is_winner}<span class="candidate-checkmark" aria-label="checkmark, winner">✓</span>{/if} Trump
            </dt>
          </div>
        </dl>
    
    <!-- bar chart info -->
    <div class="position-relative">
      <div class="display-flex w-full bar-height">
        <div class="bg-dem l-bar" style="width: {harrisWidth}%" />
        {#if remainingWidth > 0}
          <div class="bg-neutral g-bar" style="width: {remainingWidth}%" />
        {/if}
        <div class="bg-gop r-bar" style="width: {trumpWidth}%" />
      </div>

      <!-- balance bar -->
      <div
        class="display-flex justify-center w-full position-absolute top-0 bar-height">
        <div class="balance-bar" />
      </div>

      <!-- votes display -->
      <div class="display-flex justify-between color-dark-grey text-sm mt-8">
        <dt class="balance-name">
          <p class="vote-totals m-0">
            {intcomma(harris.votes)}
            vote{pluralize(harris.votes)}
          </p>
        </dt>
        <dt class="balance-name">
          <p class="vote-totals m-0">
            {intcomma(trump.votes)}
            vote{pluralize(trump.votes)}
          </p>
        </dt>
      </div>
    </div>
  </div>

  <!-- trump section -->
    <div class="display-flex justify-between text-sm color-dark-grey image-style">
        <div class="duo-head right trump-headshot">
          <Photos
            name="Donald Trump"
            src={trumpHead.jpg || trumpHead.png}
            avif={trumpHead.avif}
            webp={trumpHead.webp}
            party={trump.party}
          />
        </div>
    </div>
  </div>